import { apiUrl } from '../../../components/AppDataProvider'
import httpClient from '../../../components/CustomHttpClient'
import { downloadContent } from '../../../utils/utils'

export const downloadOfferCsv = async (offerId: string, offerName: string) => {
  const url = `${apiUrl}/joint-purchase/${offerId}/csv`
  const { body } = await httpClient(url)
  downloadContent(body, `${offerName}.csv`)
}
